import { Icon } from './Icon.jsx';
import { usePdf } from '../store/pdfStore.js';
import { useT } from '../i18n/index.js';

export function Toolbar({ onExport, onAddPdf, onChangeGrid, gridSize, busy }) {
  const t = useT();
  const selected = usePdf((s) => s.selected);
  const pages = usePdf((s) => s.pages);
  const rotateSelected = usePdf((s) => s.rotateSelected);
  const deleteSelected = usePdf((s) => s.deleteSelected);
  const duplicateSelected = usePdf((s) => s.duplicateSelected);
  const selectAll = usePdf((s) => s.selectAll);
  const clearSelection = usePdf((s) => s.clearSelection);

  const has = selected.size > 0;
  const selLabel = selected.size > 1
    ? t('toolbar.selected_plural', { n: selected.size, t: pages.length })
    : t('toolbar.selected', { n: selected.size, t: pages.length });

  return (
    <div className="toolbar">
      <button className="btn sm" onClick={selectAll} disabled={!pages.length}>
        <Icon name="selectAll" size={14} /> {t('toolbar.select_all')}
      </button>
      <button className="btn sm ghost" onClick={clearSelection} disabled={!has}>
        {t('toolbar.deselect')}
      </button>
      <span className="chip">{selLabel}</span>

      <span className="divider" />

      <button className="btn sm" disabled={!has} onClick={() => rotateSelected(-90)}>
        <Icon name="rotateCCW" size={14} /> {t('toolbar.rotate_left')}
      </button>
      <button className="btn sm" disabled={!has} onClick={() => rotateSelected(90)}>
        <Icon name="rotateCW" size={14} /> {t('toolbar.rotate_right')}
      </button>
      <button className="btn sm" disabled={!has} onClick={duplicateSelected}>
        <Icon name="copy" size={14} /> {t('toolbar.duplicate')}
      </button>
      <button className="btn sm danger" disabled={!has} onClick={deleteSelected}>
        <Icon name="trash" size={14} /> {t('toolbar.delete')}
      </button>

      <span className="divider" />

      <button className="btn sm" onClick={onAddPdf}>
        <Icon name="merge" size={14} /> {t('toolbar.add_pdf')}
      </button>

      <span style={{ marginLeft: 'auto' }} />

      <select
        className="btn sm"
        value={gridSize}
        onChange={(e) => onChangeGrid(e.target.value)}
        title={t('toolbar.thumb_size')}
        aria-label={t('toolbar.thumb_size')}
      >
        <option value="small">{t('toolbar.size_small')}</option>
        <option value="medium">{t('toolbar.size_medium')}</option>
        <option value="large">{t('toolbar.size_large')}</option>
      </select>

      <button className="btn sm primary" onClick={onExport} disabled={!pages.length || busy}>
        <Icon name="download" size={14} /> {t('app.save_copy')}
      </button>
    </div>
  );
}
